export const materials = {
    Plastik: "🧴",
    Metall: "⚙️",
    Stoff: "🧵",
    Wachs: "🕯️",
    Holz: "🌳",
    Papier: "📄",
    Keramik: "🏺",
    Glas: "🍷"
  };

  export const attackTypes = {
    Wucht: "🔨", // Beispiel: Hammer oder Keule
    Schnitt: "🗡️", // Beispiel: Schwert
    Stich: "🏹", // Beispiel: Pfeil oder Bogen
    Hitze: "🔥", // Beispiel: Feuer
    Kälte: "❄️", // Beispiel: Eis
    Druck: "🌀", // Beispiel: Luftwirbel
    Ätzend: "🧪", // Beispiel: Säuren
    Arkan: "✨", // Beispiel: Magie
    Energie: "⚡" // Beispiel: Blitze
  };

  export const movementTypes = {
    Boden: "🚶", // Beispiel: Zu Fuß oder auf dem Boden
    Wasser: "🚢", // Beispiel: Schiffe oder Boote
    Amphibisch: "🐸", // Beispiel: An Land und Wasser
    Luft: "✈️" // Beispiel: Flugzeuge oder fliegende Einheiten
  };

  export const more = {
    hit_points: "❤️",
    height_cm: "📏",
    volume_cm3: "📦 ",
    summoning_cost: "💠"
  };